import { HttpError } from "ra-core";
import { getSupabaseClient } from "./supabase";
import { timedFetch } from "./network";

export const crmHttpClient = async (url: string, options: any = {}) => {
  const { data, error } = await getSupabaseClient().auth.getSession();
  if (error) throw error;
  const headers = new Headers(options.headers);
  headers.set("apikey", import.meta.env.VITE_SB_PUBLISHABLE_KEY);
  if (!headers.has("Accept")) headers.set("Accept", "application/json");
  if (data.session)
    headers.set("Authorization", `Bearer ${data.session.access_token}`);
  if (
    options.body &&
    !headers.has("Content-Type") &&
    !(options.body instanceof FormData)
  )
    headers.set("Content-Type", "application/json");
  const response = await timedFetch(url, { ...options, headers });
  const body = await response.text();
  let json: any;
  try {
    json = JSON.parse(body);
  } catch {
    json = undefined;
  }
  if (!response.ok)
    throw new HttpError(
      json?.message ?? response.statusText,
      response.status,
      json,
    );
  return { status: response.status, headers: response.headers, body, json };
};
